import React from "react";
import "./portfolio.css";
import Vidkarya from "../../../images/Vidkarya.jpg";
import Sahay from "../../../images/Sahay.jpg";
import Walter from "../../../images/Walter.jpg";
import SQL from "../../../images/sql.png";
import Wagmi from "../../../images/wagmi.jpg";
import DevFest from "../../../images/devfest.jpg";
import MSME from "../../../images/MSMEPayments.com.jpg";
import Kutniti from "../../../images/kutniti.watch.png";
import Medixtrans from "../../../images/medixtrans.png";

const data = [
  {
    id: 1,
    image: Vidkarya,
    title: "Vidkarya Website",
    github: "https://github.com/LuckYYadav15/Vidkarya_FrontEnd",
    demo: "https://vidkarya.vercel.app/",
  },
  {
    id: 2,
    image: Kutniti,
    title: "Kutniti Website",
    github: "https://github.com/LuckYYadav15/kutniti-frontend ",
    demo: "https://kutniti.watch/",
  },
  {
    id: 3,
    image: Walter,
    title: "Desktop Assistant",
    github: "https://github.com/LuckYYadav15/Desktop-Assistant",
    demo: "https://github.com/LuckYYadav15/Desktop-Assistant",
  },
  {
    id: 4,
    image: Medixtrans,
    title: "mediXtrans",
    github: "https://github.com/MediXTrans/MediXtranS-v2",
    demo: "https://medixtrans.vercel.app/home",
  },
  {
    id: 5,
    image: SQL,
    title: "DBMS-Sql-Website",
    github: "https://github.com/LuckYYadav15/dbms-project",
    demo: "https://dbms-project-eosin.vercel.app/",
  },
  {
    id: 6,
    image: Wagmi,
    title: "SIH Project",
    github: "https://github.com/LuckYYadav15/WAGMI-FrontEnd",
    demo: "https://wagmi-lake.vercel.app/",
  },
  {
    id: 7,
    image: DevFest,
    title: "DevFest-Hubli-2022",
    github: "https://github.com/LuckYYadav15/DevFest-2022",
    demo: "https://devfest2022.vercel.app/",
  },
  {
    id: 8,
    image: MSME,
    title: "MSMEPayments.com",
    github: "https://github.com/VKJ-Law-Offices",
    demo: "https://frontend-msme-pay.vercel.app/",
  },
  {
    id: 9,
    image: Sahay,
    title: "Deshpande Hackathon-Sahay",
    github: "https://github.com/Bn-Bt/frontEnd",
    demo: "https://front-end-mauve-gamma.vercel.app/",
  },
];

const portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a href={github} className="btn" target="_blank">
                  Github
                </a>
                <a href={demo} className="btn btn-primary" target="_blank">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default portfolio;
